
class LoginResponse {
    constructor(user, tokens, projects) {
        this.user = user;
        this.token = tokens;
        this.projects = projects;
    }
}

export default LoginResponse;